import React from 'react'
import * as constants from '../../../constants'

import withStyles from '@material-ui/core/styles/withStyles'

import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import DialogActions from '@material-ui/core/DialogActions'
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const options = [
  { name: 'Normal' },
  { name: 'Puzzle' },
];

class EditModeMenu extends React.Component {
  state = {
    anchorEl: null,
    openConfirmDialogA: false,
    openConfirmDialogB: false,
  }

  handleClickListItem = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleMenuItemClick = (selectedIndex, confirm) => (event) => {
    if (confirm) {
      if (selectedIndex === constants.editModeType.PUZZLE) {
        this.setState({ openConfirmDialogA: true })
      }
      else if (selectedIndex === constants.editModeType.NORMAL) {
        this.setState({ openConfirmDialogB: true })
      }
    }
    else {
      this.props.onSelected(this.props.bid, selectedIndex)
      this.setState({ anchorEl: null })
    }
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }
  
  confirmDialogProps = {
    handleClose: (dialogName) => () => {
      this.setState({ anchorEl: null })
      this.setState({ [dialogName]: false })
    },
    handleOK: (dialogName, selectedIndex) => () => {
      this.props.onSelected(this.props.bid, selectedIndex)
      this.setState({ anchorEl: null })
      this.setState({ [dialogName]: false })
    }
  }
  
  render() {
    const { classes, editMode, confirm } = this.props
    const { anchorEl, openConfirmDialogA, openConfirmDialogB } = this.state

    return (
      <div className={classes.root}>
        {(() => {
          switch (editMode) {
            case constants.editModeType.NORMAL:
              return <Button onClick={this.handleClickListItem}>NORMAL</Button>
            case constants.editModeType.PUZZLE:
              return <Button onClick={this.handleClickListItem}>PUZZLE</Button>
            default:
              break
          }
        })()}
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {options.map((option, index) => {
            return (
            <MenuItem
              key={option.name}
              selected={index === editMode}
              onClick={this.handleMenuItemClick(index, confirm)}
            >
              {option.name}
            </MenuItem>
          )})}
        </Menu>
        <Dialog open={openConfirmDialogA} onClose={this.confirmDialogProps.handleClose('openConfirmDialogA')}>
          <DialogTitle><Word wid={WID.EDIT_MODE_MENU.PUZZLE_CONFIRM_DIALOG.TITLE}/></DialogTitle>
          <DialogContent>
            <Typography>
              <Word wid={WID.EDIT_MODE_MENU.PUZZLE_CONFIRM_DIALOG.CONTENT}/>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.confirmDialogProps.handleOK('openConfirmDialogA', constants.editModeType.PUZZLE)} color="primary">
              OK
            </Button>
            <Button onClick={this.confirmDialogProps.handleClose('openConfirmDialogA')} color="primary">
              Canncel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openConfirmDialogB} onClose={this.confirmDialogProps.handleClose('openConfirmDialogB')}>
          <DialogTitle><Word wid={WID.EDIT_MODE_MENU.NORMAL_CONFIRM_DIALOG.TITLE}/></DialogTitle>
          <DialogContent>
            <Typography>
              <Word wid={WID.EDIT_MODE_MENU.NORMAL_CONFIRM_DIALOG.CONTENT}/>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.confirmDialogProps.handleOK('openConfirmDialogB', constants.editModeType.NORMAL)} color="primary">
              OK
            </Button>
            <Button onClick={this.confirmDialogProps.handleClose('openConfirmDialogB')} color="primary">
              Canncel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(EditModeMenu);



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/EditModeMenu.js